import { sample } from 'effector';
import { historyPush, signout } from '@features/common';
import { NEW_OPENED_ID } from '../detail-sdui';
import { addClicked, closeDetail, PageGate, path } from '../page';
import { outerEvents, selectTableRow } from './helpers';
import { $openedId, setOpenedId } from './model';

$openedId
  .on(setOpenedId, (_, ticketId) => ticketId)
  .reset([PageGate.close, closeDetail, signout]);

sample({
  clock: PageGate.state,
  filter: ({ ticketId }) => !!ticketId,
  fn: ({ ticketId }) => ticketId,
  target: setOpenedId,
});

export const statuses = {
  openedOnlyTable: sample({
    clock: $openedId,
    filter: (openedId) => openedId === null,
  }),
  openedTableAndExistedTicket: sample({
    clock: $openedId,
    filter: (openedId) => !!openedId && openedId !== NEW_OPENED_ID,
  }),
  openedTableAndNewTicket: sample({
    clock: $openedId,
    filter: (openedId) => !!openedId && openedId === NEW_OPENED_ID,
  }),
};

sample({
  clock: $openedId,
  fn: (openedId) =>
    openedId && openedId !== NEW_OPENED_ID ? `${path}/${openedId}` : path,
  target: historyPush,
});

sample({
  clock: [statuses.openedTableAndExistedTicket, statuses.openedTableAndNewTicket],
  target: addClicked,
});

selectTableRow();

outerEvents();
